import React from 'react';
import { motion } from 'framer-motion';
import Container from '../../layout/Container';

const Vision = () => {
  return (
    <section className="py-16 bg-blue-50">
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl font-bold mb-6 text-blue-800">Our Vision</h2>
            <p className="text-gray-700">
              At Bytematic, we envision a future where technology seamlessly integrates with business 
              operations, creating efficient, secure, and sustainable environments that drive innovation 
              and growth. We strive to be at the forefront of IT infrastructure solutions, continuously 
              evolving to meet the changing needs of our clients.
            </p>
            
            <div className="mt-8 bg-white p-6 rounded-lg shadow-sm border border-blue-100">
              <p className="italic text-blue-700 text-lg">
                "To empower businesses through technology, enabling growth, innovation, and excellence in everything they do."
              </p>
            </div>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl font-bold mb-6 text-blue-800">Our Mission</h2>
            <p className="text-gray-700">
              Our mission is to deliver high-quality hardware and IT infrastructure solutions that address 
              the unique challenges of each client. We are committed to building long-term relationships 
              based on trust, reliability, and exceptional service, ensuring that our clients have the 
              technological foundation they need to succeed.
            </p>
            
            <div className="mt-8 bg-white p-6 rounded-lg shadow-sm border border-blue-100">
              <h3 className="text-xl font-semibold mb-3 text-gray-800">Core Values</h3>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span className="text-gray-700">Excellence in service delivery and technical expertise</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span className="text-gray-700">Integrity and transparency in all our dealings</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span className="text-gray-700">Innovation and adaptability in a rapidly changing industry</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span className="text-gray-700">Client-centric approach to everything we do</span>
                </li>
              </ul>
            </div>
          </motion.div>
        </div>
      </Container>
    </section>
  );
};

export default Vision;